import React from "react";
import { logEvent, logInteractionEvent } from "../../../utils/appInsight";
import { useSelector } from "react-redux";

const ActivityTemplateButton = ({ template, color, withText = true }) => {
  const section = useSelector((state) => state.progress.section);

  return (
    <div>
      <div className="flex justify-center">
        <a
          onClick={() => {
            logEvent({
              name: "TemplateDownloaded",
              properties: {
                template,
                section,
              },
            });
            logInteractionEvent("TemplateDownloaded", {
              section,
              template: template.fileUrl,
            });
          }}
          href={template.fileUrl}
          download={template.fileUrl}
          className={`btn-lg btn-download flex p-10 sm:py-5 uppercase bg-${color} text-white hover:bg-gray-900 hover:text-white font-secondary font-bold mx-5 mb-5`}
        >
          <strong className="flex items-center font-bold">
            <span className="flex-grow">DOWNLOAD TEMPLATE</span>
            <span className="icon-download ml-5"></span>
          </strong>
        </a>
      </div>

      {withText && (
        <div className="text-sm text-left max-w-180 mx-auto tracking-slightwide leading-sm">
          <p>
            Don’t reinvent the wheel. Take this template and modify it for your
            own needs. Let someone else do the heavy lifting for a change!
          </p>
        </div>
      )}
    </div>
  );
};

export default ActivityTemplateButton;
